
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tokenized-assets",
      function () {
        return require("private-next-pages/tokenized-assets.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tokenized-assets"])
      });
    }
  